import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomProductListComponent } from './product-list.component';
import { CmsConfig, FeaturesConfigModule, I18nModule, UrlModule, provideConfig } from '@spartacus/core';
import { CustomProductListComponentService } from './custom-product-list-component.service';
import {
  AtMessageModule,
  IconModule,
  ItemCounterModule,
  ListNavigationModule,
  MediaModule,
  OutletModule,
  PageComponentModule,
  ProductListComponentService,
  SpinnerModule,
  StarRatingModule,
} from '@spartacus/storefront';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { RouterModule } from '@angular/router';
import { CustomProductGridItemComponent } from './product-grid-item/product-grid-item.component';
import { CustomProductListItemComponent } from './product-list-item/product-list-item.component';
import { CustomProductScrollComponent } from './product-scroll/product-scroll.component';
import { ProductCardComponent } from '../product-card/product-card.component';
import { ProductRowComponent } from '../product-row/product-row.component';
import { ProductViewModule } from './product-view/product-view.module';
import { FacetSortSelectModule } from './product-facet-navigation/facet-sort-select/facet-sort-select.module';
import { PlpPageNameModule } from './plp-page-name/plp-page-name.module';
import { PlpQtyResultsModule } from './plp-qty-results/plp-qty-results.module';
import { PlpPaginationModule } from './plp-pagination/plp-pagination.module';
import { CustomActiveFacetsModule } from './product-facet-navigation/active-facets/active-facets.module';
import { CustomPaginationModule } from '../../misc/pagination/pagination.module';
import { ScreenViewModule } from '../../../../core/directives/screen-view/_screen-view.module';
import { CounterResultsModule } from './counter-results/counter-results.module';
import { ProductListItemCompactComponent } from './product-list-item-compact/product-list-item-compact.component';
import { ListViewModeModule } from './list-view-mode/list-view-mode.module';
import { ObsoleteProductModule } from './list-view-mode/obsolete-product/obsolete-product.module';

@NgModule({
  declarations: [
    CustomProductListComponent,
    CustomProductListItemComponent,
    CustomProductGridItemComponent,
    CustomProductScrollComponent,
  ],
  imports: [
    AtMessageModule,
    CommonModule,
    I18nModule,
    IconModule,
    InfiniteScrollModule,
    ItemCounterModule,
    ListNavigationModule,
    MediaModule,
    OutletModule,
    PageComponentModule,
    RouterModule,
    SpinnerModule,
    StarRatingModule,
    UrlModule,
    FeaturesConfigModule,
    CustomPaginationModule,
    ProductCardComponent,
    ProductRowComponent,
    ProductViewModule,
    FacetSortSelectModule,
    PlpPageNameModule,
    PlpQtyResultsModule,
    PlpPaginationModule,
    CustomActiveFacetsModule,
    PlpPaginationModule,
    ScreenViewModule,
    CounterResultsModule,
    ProductListItemCompactComponent,
    ListViewModeModule,
    ObsoleteProductModule,
  ],
  exports: [
    CustomProductListComponent,
    CustomProductListItemComponent,
    CustomProductGridItemComponent,
    CustomProductScrollComponent,
  ],
  providers: [
    { provide: ProductListComponentService, useClass: CustomProductListComponentService },
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CMSProductListComponent: {
          component: CustomProductListComponent,
          data: {
            composition: {
              inner: ['ProductAddToCartComponent'],
            },
          },
        },
        ProductGridComponent: {
          component: CustomProductListComponent,
          data: {
            composition: {
              inner: ['ProductAddToCartComponent'],
            },
          },
        },
        SearchResultsListComponent: {
          component: CustomProductListComponent,
          data: {
            composition: {
              inner: ['ProductAddToCartComponent'],
            },
          },
        },
        SearchResultsGridComponent: {
          component: CustomProductListComponent,
          data: {
            composition: {
              inner: ['ProductAddToCartComponent'],
            },
          },
        },
      },
    }),
  ],
})
export class CustomProductListModule {}
